export default __webpack_public_path__ + "static/media/qs_risk_free.2b2d2b7e.svg";